import { formatDate, isoDateInBerlin } from './format.ts';

/** Fachlicher Tag eines Eintrags (Europe/Berlin, ISO). */
export function chatterDay(at: string): string {
  return isoDateInBerlin(new Date(at));
}

/**
 * „Heute“, „Gestern“ oder das Datum (Tageszeile der Zeitleiste). `today` = fachliches Heute (Server bzw. Testuhr über
 * `useToday`), nie die Uhr des Browsers.
 */
export function chatterDayLabel(day: string, today: string): string {
  if (day === today) return 'Heute';
  const yesterday = new Date(`${today}T00:00:00Z`);
  yesterday.setUTCDate(yesterday.getUTCDate() - 1);
  if (day === yesterday.toISOString().slice(0, 10)) return 'Gestern';
  return formatDate(day);
}
